import { useQuery } from '@tanstack/react-query';
import {
  clientImageAssetsService,
  type ClientImageAssetListParams,
} from '../services/clientImageAssetsService';

export const useClientImageAssetsList = (
  tenantId: string | null,
  params: ClientImageAssetListParams = {},
  options?: { enabled?: boolean }
) => {
  return useQuery({
    queryKey: ['clientImageAssets', 'list', tenantId, params],
    queryFn: async () => {
      if (!tenantId) return null;
      return clientImageAssetsService.list(tenantId, params);
    },
    enabled: !!tenantId && (options?.enabled ?? true),
    staleTime: 60_000,
    placeholderData: (prev) => (prev?.tenant_id === tenantId ? prev : undefined),
  });
};
